module.exports = __webpack_public_path__ + "img/franklin.79ab0516.jpg";